import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NavParams } from '@ionic/angular';

@Component({
  selector: 'app-carosello',
  templateUrl: './carosello.page.html',
  styleUrls: ['./carosello.page.scss'],
})
export class CaroselloPage implements OnInit {
  imgPath:any;

  constructor(private modalCtrl: ModalController, private _navParams: NavParams) {
    this.imgPath=this._navParams.data.img;
   }

  ngOnInit() {
  }


}
